// src/api/generateAudio.ts
import api from './api';

export type TtsStatus =
  | 'created'
  | 'skipped_existing'
  | 'skipped_no_text'
  | 'skipped_too_long'
  | 'error';

export type TtsResult = {
  contentId: number;
  lang: string;
  status: TtsStatus | string;
  reason?: string | null;
  audioId?: number | null;
  filePath?: string | null;
  durationSeconds?: number | null; // NOWE
};

export type TtsSummary = {
  total: number;
  created: number;
  skipped: number;
  errors: number;
};

export type GenerateAudioPayload = {
  contentIds: number[];
  languages?: string[];
  force?: boolean;
};

export async function generateAudioForContents(
  payload: GenerateAudioPayload
): Promise<{ summary: TtsSummary; results: TtsResult[] }> {
  const res = await api.post('/admin/tts/generate', payload);
  return res.data;
}

/**
 * Struktura /contents/details — dopasowana do backendowego SELECT-a
 */
export type ContentDetails = {
  id: number;
  title: string;
  type: string;
  language: string;
  is_visible: boolean;
  difficulty_level: string | null;
  has_description: boolean;
  is_premium: boolean;
  created_at: string;

  category_id: number | null;
  category_title: string | null;

  authors: string | null;
  tags: string | null;

  avg_rating: string | null;
  ratings_count: number;

  created_by_name: string | null;
  created_by_email: string | null;
  last_edited_by_name: string | null;
  last_edited_by_email: string | null;
  last_edited_at: string | null;
};

export async function getContentsDetails(): Promise<ContentDetails[]> {
  const res = await api.get('/contents/details');
  return res.data as ContentDetails[];
}

/* ===== Recalc durations endpoint ===== */

export type RecalcDurationsResponse = {
  contentId: number;
  updatedCount: number;
  failedCount: number;
  updated: {
    id: number;
    file_path: string;
    duration_seconds: number | null;
  }[];
  failed: {
    id: number;
    file_path: string;
    reason: string;
  }[];
};

export async function recalcDurationsForContent(
  contentId: number
): Promise<RecalcDurationsResponse> {
  const res = await api.post('/admin/tts/recalc-durations', { contentId });
  return res.data as RecalcDurationsResponse;
}
